import React from 'react';
import PopupModal from "../../../../../../../../../components/Modal/PopupModal";
import {useTranslation} from "react-i18next";
import MultistoreWithHomePageDeliverySection from "../Delivery/MultistoreWithHomePageDeliverySection";
import MultistoreWithMapHomePageOtherTypesSection from "../MultistoreWithMapHomePageOtherTypesSection";
import {OrderType} from "../../../../../../../../../services/Api/types";
import {MultistoreMenuItem} from "../../../../../../../utils/types";

interface Props {
    show: boolean;
    onHide: () => void;
    orderTypes: OrderType[];
    selectedProduct?: MultistoreMenuItem;
}

const MultistoreMenuOrderTypesModal = ({show, onHide, orderTypes, selectedProduct}: Props) => {
    const {t} = useTranslation();

    return (
        <PopupModal
            key={show ? "open" : "closed"}
            className="multistore-with-map-home-page multistore-menu-order-types-modal"
            title={t("modules.multistore.field.select_order_type.title")}
            show={show}
            onHide={onHide}
            bodyContent={
                <div className="online-order-section">
                    <div className="online-order-section-inner-container">
                        <div className="online-order-section-cards">
                            {orderTypes.includes(OrderType.DELIVERY) && (
                                <MultistoreWithHomePageDeliverySection
                                    placeLinkParams={selectedProduct ? [`product_name=${selectedProduct.name}`] : undefined}/>
                            )}
                            {
                                orderTypes.length > 0 && orderTypes.some(orderType => orderType !== OrderType.DELIVERY) && (
                                    <MultistoreWithMapHomePageOtherTypesSection orderTypes={orderTypes}/>
                                )
                            }
                        </div>
                    </div>
                </div>
            }
        />
    )
}

export default MultistoreMenuOrderTypesModal;